import type { ReactNode } from 'react';

import { NavigationBar } from '@/shared/ui/navigation/navigation-bar';
import { NavigationSidebar } from '@/shared/ui/navigation/navigation-sidebar';

type Props = {
    dropdown?: ReactNode;
    children: ReactNode;
};

// Composes the app shell for every authenticated page. Kept as one definition, opted into per
// page, so the header and sidebar render exactly once each rather than being duplicated per page.
export function AuthenticatedShell({ dropdown, children }: Props) {
    return (
        <div className="bg-background flex h-dvh flex-col overflow-hidden pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]">
            <NavigationBar dropdown={dropdown} />
            <div className="flex min-h-0 flex-1">
                <NavigationSidebar />
                {children}
            </div>
        </div>
    );
}
